<jml-lib-dynamic-table
  *ngIf="tableData"
  [tableData]="tableData"
  [mainType]="mainType"
  [mainId]="mainId"
  [mainRepr]="mainRepr"
  (entityOperation)="onEntityOperation()"
  [isRootEntity]="false"
></jml-lib-dynamic-table>
